/*eslint no-array-constructor: "off"*/
/*eslint react-hooks/exhaustive-deps: "off"*/
import { consumirServicioEncirptacion } from "api";
import BreadCurmb from "components/BreadCrumbMex/BreadCrumb";
import BreadCurmbPasos from "components/BreadCrumbMex/BreadCrumbTipo2";
import Page from "components/Page";
import EmisionFooterBarButtons from "components/Polizas/EmisionFooterBarButtons";
import FormContratanteAsegurado from "components/Polizas/FormContratanteAsegurado";
import { urlEmisionPoliza, urlSeccionCargaContratante } from "constants/urls";
import { useNavbarContext } from "contexts/NavbarContext";
import withValidarRecuperar from "HOC/withValidarRecuperar";
import useBuscarColonias from "hooks/useBuscarColonias";
import useBuscarMunicipios from "hooks/useBuscarMunicipios";
import useCustomForm from "hooks/useCustomForm";
import usePasosEmision from "hooks/usePasosEmision";
import React, { useCallback, useEffect, useState } from "react";
import { FormProvider } from "react-hook-form";
import { PASOS_BREADCRUMBS } from "utils/constants";
import PRODUCTOS from "utils/constants/PRODUCTOS";
import { isArray, mapArrayDropdownOptions } from "utils/funciones";
import Loading from "wrappers/Loading";
import { predicateBuscarValidaciones } from "./utils/funciones";
import useCustomToast from "hooks/useCustomToasts";

const ContainerEmisionAsegurado = ({ qParams, history }) => {
  const { idPoliza, codProducto } = qParams;
  const methods = useCustomForm({ mode: "onChange" });

  const { addWarningToast, addSuccessToast } = useCustomToast();

  const [catalogo, setCatalogo] = useState(null);
  const [loading, setLoading] = useState(true);
  const { verificarPolizaCompletada } = usePasosEmision();

  const municipiosHook = useBuscarMunicipios();
  const { setMunicipios } = municipiosHook;
  const coloniasHook = useBuscarColonias();
  const { setColonias } = coloniasHook;

  const [routes, setRoutes] = useState({});
  const [idAsegurado, setIdAsegurado] = useState("");

  const { setProductoActivo } = useNavbarContext();
  const init = useCallback(async () => {
    setLoading(true);
    setProductoActivo(codProducto);

    const Body = {
      polCodigo: idPoliza,
      prodCodigo: codProducto,
      pasoRevContratante: "obtenerAsegurado",
      pasoCatContratante: "catalogoContratante",
      formulario: "asegurado",
    };

    const res = await consumirServicioEncirptacion(urlSeccionCargaContratante, Body);
    console.log("RES: ", res);

    if (res?.transaccion && res?.data) {
      const { municipios, colonias, catalogo } = res?.data;

      if (!catalogo?.camposAdicionales?.permitirEmitir) {
        addWarningToast("No se puede emitir esta póliza", { autoDismiss: false });
      }

      if (catalogo?.DatosContratanteAsegurado) {
        methods.reset(catalogo.DatosContratanteAsegurado);
        if (isArray(municipios)) {
          setMunicipios(municipios?.map(mapArrayDropdownOptions));
        }

        if (isArray(colonias)) {
          setColonias(colonias?.map(mapArrayDropdownOptions));
        }
      }
      verificarPolizaCompletada(catalogo?.pasosRedireccionamiento);
      setRoutes(catalogo?.pasosRedireccionamiento);
      setCatalogo(catalogo);
      if (catalogo?.idAsegurado) {
        setIdAsegurado(catalogo?.idAsegurado);
      }
    }

    setLoading(false);
  }, []);

  useEffect(() => {
    init();
  }, [init]);

  const guardarInformacion = async (data, guardarDatos = true) => {
    setLoading(true);
    let Data = {
      guardarDatos,
      datosCotizador: {
        prodCodigo: PRODUCTOS.AUTO,
        cotPasoCodigo: "asegurado",
        polCodigo: idPoliza,
        accion: "crear",
        idAsegurado: "",
        datosContratanteAsegurado: data,
      },
    };

    if (idAsegurado !== "") {
      Data.datosCotizador.idAsegurado = idAsegurado;
      Data.datosCotizador.accion = "modificar";
    }

    const res = await consumirServicioEncirptacion(urlEmisionPoliza, Data);
    console.log("RES: ", res);
    if (res.transaccion) {
      if (guardarDatos === false) {
        const route = routes.find((e) => e.codigo === "asegurado");
        return history.push(`${route.goTo}`);
      }
      addSuccessToast("Se ha guardado la información de forma correcta");
    } else {
      addWarningToast("Ha ocurrido un problema al momento de guardar el asegurado");
    }

    setLoading(false);
    init();
  };

  const onSubmit = async (data) => {
    console.log("yyyy", catalogo.validaciones);
    const validaciones = catalogo.validaciones
      .filter(
        predicateBuscarValidaciones(data?.tipoPersona?.value, codProducto, "asegurado")
      )
      .map((validacion) => methods.validate(validacion.name, validacion.onSubmitRules))
      .filter((validacion) => !validacion);

    if (validaciones?.length && validaciones.length > 0) {
      return addWarningToast("Rellene el formulario correctamente");
    }
    await guardarInformacion(data, false);
  };

  const onClickAtras = () => {
    const route = routes.find((e) => e.codigo === "asegurado");
    history.push(`${route.goBack}`);
  };

  const onGuardar = async () => {
    const isValid = await methods.trigger("tipoPersona");
    if (isValid) {
      const data = methods.getValues();
      await guardarInformacion(data);
    } else {
      addWarningToast("Debe seleccionar un tipo de persona");
    }
  };

  const onSubmitError = () => {
    addWarningToast("Rellene el formulario correctamente");
  };

  return (
    <Loading loading={loading}>
      <div className='cr-content'>
        <FormProvider {...methods}>
          <form>
            <Page>
              {codProducto !== "AUTO" && (
                <BreadCurmb {...PASOS_BREADCRUMBS[codProducto].breadCrumb} />
              )}
              {codProducto === "AUTO" && (
                <BreadCurmb
                  {...PASOS_BREADCRUMBS[codProducto].breadCrumbPasos[6].breadCrumb}
                />
              )}

              <BreadCurmbPasos {...PASOS_BREADCRUMBS[codProducto].breadCrumbPasos[6]} />

              <FormContratanteAsegurado
                title='Asegurado'
                formulario='asegurado'
                catalogo={catalogo}
                onClickAtras={onClickAtras}
                onSubmit={onSubmit}
                onGuardar={onGuardar}
                {...{
                  ...municipiosHook,
                  ...coloniasHook,
                }}
              />
            </Page>
          </form>
        </FormProvider>

        <EmisionFooterBarButtons
          onClickAtras={onClickAtras}
          onClickGuardar={onGuardar}
          onClickContinuar={methods.handleSubmit(onSubmit, onSubmitError)}
        />
      </div>
    </Loading>
  );
};

export default withValidarRecuperar(ContainerEmisionAsegurado);
